<template>
<div>
    <md-card v-show="isVisible">
        <header-form title="DETALHES DO CLIENTE" :btnHide="true">
            <div v-if="nivel == 3" class="btn-title">
                <md-button :to="{name: 'rhFuncionarioRead'}" class="md-site md-just-icon md-round">
                    <i class="fas fa-list"></i>
                    <md-tooltip md-direction="top">Lista de Funcionários</md-tooltip>
                </md-button>
            </div>
             <div v-else class="btn-title">
                <md-button v-if="permissoes.clientesRead" :to="{name: 'clientesRead'}" class="md-site md-just-icon md-round">
                    <i class="fas fa-list"></i>
                    <md-tooltip md-direction="top">Lista de Clientes</md-tooltip>
                </md-button>
            </div>
        </header-form>

        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-10 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">ID: </label>
                    <span class="text-secondary text-view">{{ cliente.id }}</span>
                </div>

                <div class="md-layout-item md-size-35 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">NOME: </label>
                    <span class="text-secondary text-view">{{ cliente.nome }}</span>
                </div>

                <div class="md-layout-item md-size-55 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">EMPRESA: </label>
                    <span class="text-secondary text-view">{{ cliente.empresa }}</span>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-20 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">CPF: </label>
                    <span class="text-secondary text-view">{{ cliente.cpf_cnpj }}</span>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">TELEFONE: </label>
                    <span class="text-secondary text-view">{{ cliente.telefone }}</span>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">CELULAR: </label>
                    <span class="text-secondary text-view">{{ cliente.celular }}</span>
                </div>

                <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <label class="text-secondary label-view">EMAIL: </label>
                    <span class="text-secondary text-view lowercase">{{ cliente.email }}</span>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-20 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">CEP: </label>
                    <span class="text-secondary text-view">{{ cliente.cep }}</span>
                </div>

                <div class="md-layout-item md-size-70 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">RUA: </label>
                    <span class="text-secondary text-view">{{ cliente.rua }}</span>
                </div>

                <div class="md-layout-item md-size-10 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">Nº: </label>
                    <span class="text-secondary text-view">{{ cliente.num }}</span>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-35 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">COMPLEMENTO: </label>
                    <span class="text-secondary text-view">{{ cliente.complemento }}</span>
                </div>

                <div class="md-layout-item md-size-30 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">BAIRRO: </label>
                    <span class="text-secondary text-view">{{ cliente.bairro }}</span>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">CIDADE: </label>
                    <span class="text-secondary text-view">{{ cliente.cidade }}</span>
                </div>

                <div class="md-layout-item md-size-10 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">UF: </label>
                    <span class="text-secondary text-view">{{ cliente.uf }}</span>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-55 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">PLANO: </label>
                    <span class="text-secondary text-view">{{ cliente.plano_valor }}</span>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">LIMITE: </label>
                    <span class="text-secondary text-view">{{ cliente.limite }}</span>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view"> LIMITE DISPONÍVEL: </label>
                    <span class="text-secondary text-view">{{ cliente.limiteDisponivel }}</span>
                </div>

            </div>

            <div>
                <md-table v-model="detalhes" md-sort="name" md-sort-order="asc" md-fixed-header md-card class="table-striped table-hover">
                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell md-label="OBSERVAÇÕES" class="uppercase" style="width: 50%" md-sort-by="descricao">{{ item.descricao }}</md-table-cell>
                        <md-table-cell md-label="USUÁRIO" class="uppercase" style="width: 30%" md-sort-by="usuario">{{ item.usuario }}</md-table-cell>
                        <md-table-cell md-label="DATA" style="width: 20%" md-sort-by="data_created">{{ item.data_created }}</md-table-cell>
                    </md-table-row>
                </md-table>
            </div>

        </md-card-content>
    </md-card>
</div>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'
import preLoader from '@/config/mixins/preLoader';
import Pagamento from '@/config/mixins/print/pagamento'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {
                parcelas: 1
            },
            permissoes: this.$store.state.usuario.permissao,
            nivel: this.$store.state.usuario.niveis[0].id,
            cliente: {},
            parcelas: [],
            message: null,
            errors: {},
            isVisible: true,
            detalhes: []
        }
    },

    created() {
        this.getCliente();
    },

    mixins: [Notify, preLoader, Pagamento],

    methods: {
        getCliente() {
            this.$http.get(this.$urlAPI + 'clientes/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.cliente = response.data.dados[0];
                        this.detalhes = response.data.detalhes
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        numParcelas(parcela) {
            let parcelas = []
            for (let i = 1; i < parcela + 1; i++) {
                parcelas.push(i);
            }
            this.parcelas = parcelas;
        },

        create() {
            this.dados.cliente_id = this.cliente.id;
            this.dados.empresa_id = this.cliente.empresa_id;
            this.$http.post(this.$urlAPI + 'pagamentos', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.pagamento(response.data.dados)
                        this.dados = {};
                        this.dados.parcelas = 1;
                        this.isVisible = true;
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        pagamento(dataComprovante) {
            this.printPagamento(dataComprovante[0])
        }
    }
};
</script>
